import { useLocation } from 'react-router';

/**
 * Custom hook to get the active modal training and its training_url
 * @param {Array} trainings - Array of training objects
 * @param {boolean} isSchoolsTrainingPage - Whether viewing school-specific trainings
 * @param {Object} school - School object
 * @param {Object} schoolGroup - School group object
 * @returns {Object} - Contains activeModal and training_url
 */
export default function useActiveModal(
    trainings,
    isSchoolsTrainingPage,
    school,
    schoolGroup
) {
    const { pathname } = useLocation();

    const urlId = isSchoolsTrainingPage
        ? pathname?.split('/')?.[4]
        : pathname?.split('/')?.[3];

    const activeModal = trainings?.find((t) => urlId === `${t.id}`);

    const training_url = activeModal
        ? activeModal.schoolable_type === 'App\\Models\\School'
            ? school?.training_url
            : schoolGroup?.training_url
        : null;

    return {
        activeModal,
        training_url,
    };
}
